import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

class Root extends React.Component {
  render() {
    if (this.props.session.jwt) {
      return (
        <Redirect to={this.props.session.origin || '/dashboard'} />
      )
    }

    window.location.href = 'https://showcase.spiralproject.org'

    return (
      <p>
        Redirecting you to
        <a href="https://showcase.spiralproject.org">
          https://showcase.spiralproject.org
        </a>
      </p>
    )
  }
}

const mapStateToProps = state => ({
  session: state.session
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Root)
